/**
 * A plain, cloneable copy of a value. IndexedDB refuses Vue's reactive proxies
 * (DataCloneError), so anything kept in the replica goes through this first.
 */
export function plain(value) {
  return value === undefined ? undefined : JSON.parse(JSON.stringify(value))
}
